import { HStack, responsive, useResponsive, ColorIcon } from "goi_common";
import { useEffect, useState } from "react";

export const DevWarningBanner = () => {
  const [isBlinking, setIsBlinking] = useState(true);
  const [isVisible, setIsVisible] = useState(true);
  const { isBiggerThanMd } = useResponsive();

  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setIsBlinking((prev) => !prev);
    }, 600);

    return () => clearInterval(blinkInterval);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <HStack
      css={responsive({
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: isBlinking ? "#8000FF" : "#6B00D9",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px",
        zIndex: 9999,
        color: "white",
        fontSize: isBiggerThanMd ? "14px" : "12px",
        fontWeight: "bold",
        wordSpacing: "4px",
        transition: "background-color 0.3s ease",
      })}
    >
      <span
        style={{
          textAlign: "center",
          whiteSpace: isBiggerThanMd ? "normal" : "pre-line",
          flex: 1,
        }}
      >
        {`⚠️ 현재 페이지는 종료된 이벤트입니다.\n1666-9784로 연락주세요`}
      </span>
      <button
        onClick={() => {
          setIsVisible(false);
        }}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "0 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "32px",
          minHeight: "32px",
        }}
        aria-label="Close warning banner"
      >
        <ColorIcon name="icon-x-mono" size={24} color="white" />
      </button>
    </HStack>
  );
};

export default DevWarningBanner;
